// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2j_tg","right":"styles_right__1X82P"};